"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Slide", {
  enumerable: true,
  get: function get() {
    return _slide["default"];
  }
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dialog = _interopRequireDefault(require("../dialog"));
var _carousel = _interopRequireDefault(require("../carousel"));
var _button = _interopRequireDefault(require("../button"));
var _modalProvider = require("../modal-provider");
var _slide = _interopRequireDefault(require("./components/slide"));
require("./swipe-deck.css");
var _excluded = ["onSlideChange", "initialCurrentSlide"],
  _excluded2 = ["color", "onClick"];
/* eslint-disable complexity */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A dialog component that contains carousel-like content, allowing you to swipe through multiple pages of content.
 *
 */
var SwipeDeck = function SwipeDeck(_ref) {
  var _ref$carouselProps = _ref.carouselProps,
    _ref$carouselProps2 = _ref$carouselProps === void 0 ? {} : _ref$carouselProps,
    _ref$carouselProps2$o = _ref$carouselProps2.onSlideChange,
    _onSlideChange = _ref$carouselProps2$o === void 0 ? function () {} : _ref$carouselProps2$o,
    _ref$carouselProps2$i = _ref$carouselProps2.initialCurrentSlide,
    initialCurrentSlide = _ref$carouselProps2$i === void 0 ? 0 : _ref$carouselProps2$i,
    carouselProps = _objectWithoutProperties(_ref$carouselProps2, _excluded),
    children = _ref.children,
    closeButtonAriaLabel = _ref.closeButtonAriaLabel,
    confirmButtonText = _ref.confirmButtonText,
    _ref$confirmButtonPro = _ref.confirmButtonProps,
    confirmButtonProps = _ref$confirmButtonPro === void 0 ? {} : _ref$confirmButtonPro,
    _ref$onCancel = _ref.onCancel,
    onCancel = _ref$onCancel === void 0 ? function () {} : _ref$onCancel;
  var _ref2 = (0, _react.useContext)(_modalProvider.ModalContext) || {},
    _ref2$closeModal = _ref2.closeModal,
    closeModal = _ref2$closeModal === void 0 ? function () {} : _ref2$closeModal;
  var cancelHandler = function cancelHandler() {
    closeModal();
    onCancel();
  };
  var _confirmButtonProps$c = confirmButtonProps.color,
    confirmButtonColor = _confirmButtonProps$c === void 0 ? 'black' : _confirmButtonProps$c,
    _confirmButtonProps$o = confirmButtonProps.onClick,
    onConfirmClick = _confirmButtonProps$o === void 0 ? function () {} : _confirmButtonProps$o,
    otherConfirmProps = _objectWithoutProperties(confirmButtonProps, _excluded2);
  var _useState = (0, _react.useState)((children && children.length - 1) === initialCurrentSlide && confirmButtonText),
    _useState2 = _slicedToArray(_useState, 2),
    showConfirmButton = _useState2[0],
    setShowConfirmButton = _useState2[1];
  var combinedCarouselProps = _objectSpread(_objectSpread({
    controlClassName: 'my0',
    activePaginatorClassName: 'bg-houseGreen'
  }, carouselProps), {}, {
    initialCurrentSlide: initialCurrentSlide,
    slidesPerPage: 1,
    showControlArrows: true,
    onSlideChange: function onSlideChange(idx) {
      setShowConfirmButton(children && children.length - 1 === idx && confirmButtonText);
      _onSlideChange(idx);
    }
  });
  (0, _react.useEffect)(function () {
    if (!children || children && !children.length) {
      setShowConfirmButton(false);
    }
  }, [children]);
  return /*#__PURE__*/_react["default"].createElement(_dialog["default"], {
    closeButtonAriaLabel: closeButtonAriaLabel,
    contentContainerProps: {
      className: 'm0 p0 pb2'
    }
    // Dialog close button will already close the modal, so no need to use the
    // cancelHandler which binds it.
    ,
    onCancel: onCancel,
    renderButtons: false,
    renderCloseButton: true
  }, /*#__PURE__*/_react["default"].createElement(_carousel["default"], _extends({
    showPagerButtons: false,
    showPaginator: true
  }, combinedCarouselProps), children), showConfirmButton && /*#__PURE__*/_react["default"].createElement(_button["default"], _extends({
    className: "sb-swipe-deck--confirmButton",
    color: confirmButtonColor,
    onClick: function onClick() {
      onConfirmClick();
      cancelHandler();
    }
  }, otherConfirmProps), confirmButtonText));
};
SwipeDeck.displayName = 'SwipeDeck';
SwipeDeck.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Props of the containing carousel component. Refer to the [Carousel](/components/carousel) page for details on these props. Note that the `slidesPerPage` is locked at 1 and cannot be overwritten.
   */
  carouselProps: _propTypes["default"].object,
  /**
   * The children passed in **must be an array of nodes.** If you only have one item to pass in, consider using a [Dialog component](/components/dialog). Note that items wrapped in Fragments, or surrounding elements will not work with the Swipe Deck.
   */
  children: _propTypes["default"].arrayOf(_propTypes["default"].node),
  /**
   * Provides an accessible label for the close button used within the underlying Dialog
   */
  closeButtonAriaLabel: _propTypes["default"].string.isRequired,
  /**
   * Text of the call to action that appears when the user navigates to the last page. Can be a string or a node to support internationalized messaging.
   */
  confirmButtonText: _propTypes["default"].node,
  /**
   * An object that defines the props for the confirmation button. Refer to the [Buttons](/components/buttons) documentation for these props.
   */
  confirmButtonProps: _propTypes["default"].object,
  /**
   * A function that gets called when the confirm button is pressed, the close buttons is pressed or when a user clicks outside of the dialog.
   */
  onCancel: _propTypes["default"].func
} : {};
var _default = exports["default"] = SwipeDeck;